import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { useContext } from 'react';
import { SynchronizationStatusContext } from '../../context/SynchronizationStatusContext';
import { IconDeprecated } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './SyncIcon.module.css';
export type SyncIconProps = ComponentProps<'span'>;
export const SyncIcon: FunctionComponent<SyncIconProps> = React.memo(props => {
  const $ = _c(9);
  const {
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const synchronizationStatus = useContext(SynchronizationStatusContext);
  const hasFailedItems = synchronizationStatus.itemsToSynchronizeInfos.some(_temp);
  const t0 = classes(className, styles.wrapper, hasFailedItems ? styles.failed : null);
  const t1 = synchronizationStatus.inProgress ? styles.animatedIcon : undefined;
  let t2;
  if ($[0] !== t1) {
    t2 = <IconDeprecated name="sync-alt" className={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== synchronizationStatus.itemsToSynchronizeInfos.length) {
    t3 = synchronizationStatus.itemsToSynchronizeInfos.length === 0 ? undefined : <span className={styles.itemCountBadge} data-testid="SyncIcon.itemCountBadge">{synchronizationStatus.itemsToSynchronizeInfos.length}</span>;
    $[2] = synchronizationStatus.itemsToSynchronizeInfos.length;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== remainingProps || $[5] !== t0 || $[6] !== t2 || $[7] !== t3) {
    t4 = <span {...remainingProps} className={t0}>{t2}{t3}</span>;
    $[4] = remainingProps;
    $[5] = t0;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
});
function _temp(info) {
  return info.failed;
}